// カスタマイズの定数
export const VEHICLE_INIT = "init";
export const VEHICLE_INFO_GET = "get";
export const VEHICLE_MEMORY_CLEAR = "clear";
export const VEHICLE_UPDATE = "update";
export const SAVE_SETTINGS = "saveSettings";
export const VEHICLE_READ_HISTORY = "read_history";
export const VEHICLE_DELETE_HISTORY = "delete_history";
export const VEHICLE_DESTINATION_GET = "destination_get";
export const VEHICLE_DESTINATION_SAVE = "destination_save";
export const VEHICLE_DESTINATION_SUPPORT_IDS = "destination_support_ids";
export const VEHICLE_UPDATE_PART = "update_part";
export const VEHICLE_UPDATE_COMMUNICATION = "update_communication";

const ERROR_MESSAGE_MAP = Object.freeze({
  [VEHICLE_INIT]: 'individual.error_Initialize_communication_error',
  [VEHICLE_INFO_GET]: 'individual.error_cstm_connect_title',
  [SAVE_SETTINGS]: 'individual.error_cstm_save_settings',
  [VEHICLE_UPDATE]: 'individual.error_cstm_data_write',
  [VEHICLE_UPDATE_PART]: 'individual.error_cstm_data_write_part',
  [VEHICLE_UPDATE_COMMUNICATION]: 'individual.error_communication_error',
  [VEHICLE_READ_HISTORY]: 'individual.error_cstm_read_settings',
  [VEHICLE_DELETE_HISTORY]: 'individual.error_cstm_delete_settings',
  [VEHICLE_DESTINATION_GET]: 'individual.error_cstm_destination_get',
  [VEHICLE_DESTINATION_SAVE]: 'individual.error_cstm_destination_save',
  [VEHICLE_DESTINATION_SUPPORT_IDS]: 'individual.error_cstm_support_did'
});

/**
 * その他エラーのメッセージkey取得
 * @param {string} action 処理内容
 */
export const getUnexpectedErrorMessageKey = (action) => {
  return ERROR_MESSAGE_MAP[action];
};

/**
 * 全システム時のシステム名
 */
export const ALL_SYSTEMS = "ALL_SYSTEMS";

/** 仕向地設定のphase定義 */
export const DESTINATION_PHASE = {
  RECONFIRMATION: "reconfirmation",
  CONFIRMATION: "confirmation",
  INPUT_CODE: "inputCode"
};

/** 仕向地設定のtype設定 */
export const DESTINATION_TYPE = {
  READ: 'read_destination',
  WRITE: 'update_destination',
  READ_MENU: 'read_menu_list',
  SUPPORT_DID: 'read_support_did',
};

/** 仕向地設定のREAD正常終了時の遷移先定義 */
export const TRANSITION = {
  TRANSITION_GET_INFORMATION: 'transition_get_information',
  TRANSITION_CONFIRMATION: 'transition_confirmation'
};

/** 
 * カスタマイズ: 設定読出しテーブル列定義
 */
export const TABLE_COLUMNS_CUSTOMIZE_READ = [
  { name: 'registered_at', label: 'message.label_measured_data_details_registered_date' },
  { name: 'description', label: 'individual.common_label_description' },
  { name: 'deleteBtn', label: 'individual.label_readiness_code_delete', useButton: true },
];

/**
 * 全カスタマイズ: テーブル列定義
 */
export const TABLE_COLUMNS_ALL_CUSTOMIZE = [
  { name: 'systemName', label: 'message.header_vehicle_table_system_name', useSort: true },
  { name: 'name', label: 'individual.header_customize_name', useSort: true },
  { name: 'currentValue', label: 'individual.header_customize_current_setting', useSort: true },
  { name: 'writeSettings', label: 'individual.header_customize_write_settings', usePulldown: true },
  { name: 'result', label: 'individual.header_customize_result', useResource: true, useSort: true },
  { name: 'description', label: 'individual.common_label_description', useSort: true }
];

export default {
  VEHICLE_INIT,
  VEHICLE_INFO_GET,
  VEHICLE_UPDATE,
  SAVE_SETTINGS,
  VEHICLE_READ_HISTORY,
  VEHICLE_DELETE_HISTORY,
  VEHICLE_DESTINATION_GET,
  VEHICLE_DESTINATION_SAVE,
  VEHICLE_DESTINATION_SUPPORT_IDS,
  DESTINATION_TYPE,
  DESTINATION_PHASE,
  TRANSITION,
  TABLE_COLUMNS_ALL_CUSTOMIZE
};